import { ApiResult, httpRequest, Urls } from './Shared';
import { OnfidoIdVerificationStatuses } from '../utilities/Enums';

const ID_VERIFICATION_URL = '/IdVerification';

export interface OnfidoIdVerificationResult {
    result: OnfidoIdVerificationStatuses;
    sdkToken: string;
    failReason: FailedReport[];
}

export interface FailedReport {
    reportType: string;
    failedBreakdowns: FailedBreakdown[];
}

export interface FailedBreakdown {
    breakdownType: string;
    failedSections: string[];
}

export const updateOnfidoApplicant = (
    dateOfBirth: string
): Promise<ApiResult<OnfidoIdVerificationResult>> => {
    return httpRequest<OnfidoIdVerificationResult>(
        `${Urls.BASE_URL}${ID_VERIFICATION_URL}/applicant`,
        'post',
        dateOfBirth
    );
};

export const startOnfidoIdCheck = (): Promise<ApiResult<OnfidoIdVerificationResult>> => {
    return httpRequest<OnfidoIdVerificationResult>(
        `${Urls.BASE_URL}${ID_VERIFICATION_URL}/checkid`,
        'get'
    );
};

export const getOnfidoCheckStatus = (): Promise<ApiResult<OnfidoIdVerificationResult>> => {
    return httpRequest<OnfidoIdVerificationResult>(
        `${Urls.BASE_URL}${ID_VERIFICATION_URL}/checkstatus`,
        'get'
    );
};

export const getCheckpointIdRequestId = (): Promise<ApiResult<CheckpointIdResponse>> => {
    return httpRequest<CheckpointIdResponse>(
        `${Urls.BASE_URL}${ID_VERIFICATION_URL}/getCheckpointIdRequestId`,
        'get'
    );
};

export enum IdVerificationTypes {
    None = 0,
    CheckpointId = 1,
    Onfido = 2
}

export interface CheckpointIdResponse {
    requestId: string;
}

export interface EventData {
    attemptsLeft: number;
    document: Document;
    documentType: number;
    invalidDataErrors: string[];
    status: number;
    validationRequestId: string;
    validationResponseId: number;
    validationStatus: ValidationStatus;
}

export interface Document {
    abbr3Country: string;
    abbrCountry: string;
    address: string;
    city: string;
    class: string;
    country: string;
    dob: string;
    expires: string;
    eyes: string;
    familyName: string;
    firstName: string;
    fullName: string;
    gender: string;
    hair: string;
    height: string;
    id: string;
    idType: string;
    issued: string;
    middleName: string;
    privateName: string;
    state: string;
    template: string;
    weight: string;
    zip: string;
}

export interface ValidationStatus {
    documentIsValid: boolean;
    expired: boolean;
    faceIsValid: boolean;
}



// WEBPACK FOOTER //
// ./src/api/IdVerification.ts